import { Faq } from "../../blocks/faq/faq";
import { Footer } from "../../blocks/Footer/Footer";
import { MenuBottom } from "../../blocks/MenuBottom/MenuBottom";
import { Services } from "../../blocks/sevices/services";
import "../../core/core.css";
import ".././page.css";

import { EBlockType, UslugaFindByUrlResponse } from "@project/shared-types";
import { useLoaderData, useLocation } from "react-router";
import { canonicalPath } from "../../utils/canonical";
import { NewPayment } from "../../blocks/NewPayment/NewPayment";
import Header from "../../components/header/header";
import { ScrollBlock } from "../../components/others/ScrollBlock";
import { UserProvider } from "../../context/user/UserContext";
import { DataProvider } from "../../hooks/DataContext";
import { SupportProvider } from "../../Support/SupportProvider";
const PaymentPage = () => {
  const data = useLoaderData<UslugaFindByUrlResponse>();
  const currentPage = useLocation();
  return (
    <DataProvider>
      <UserProvider>
        <SupportProvider>
          <title>{data.page?.title + " Оформление заказ"}</title>
          <link
            rel="canonical"
            href={`https://hmrep.ru${canonicalPath(currentPage.pathname)}`}
          />
          <meta
            name="description"
            content={
              data.page?.description +
              " Оформление заказ с текстом отзывов и фото"
            }
          />
          <meta
            property="og:title"
            content={data.page?.title + " Оформление заказ"}
          />
          <meta
            property="og:description"
            content={
              data.page?.description +
              " Оформление заказ с текстом отзывов и фото"
            }
          />
          <div className="body">
            <ScrollBlock></ScrollBlock>
            <Header></Header>
            <div className="blocks">
              <NewPayment
                block={{
                  title: "Быстрое оформление заказа",
                  type: EBlockType.UFASTPAYMENT,
                  id: "fast_payment",
                }}
              ></NewPayment>
              <Faq></Faq>
              <Services></Services>
              <Footer></Footer>
            </div>
            <MenuBottom></MenuBottom>
          </div>
        </SupportProvider>
      </UserProvider>
    </DataProvider>
  );
};

export default PaymentPage;
